import { clientEndpoint } from 'src/constants.js'

const NOT_FOUND_URL = `${clientEndpoint}/404`

export { NOT_FOUND_URL }
